import { Link } from "react-router-dom";
import ScrollReveal from "../../../components/feature/ScrollReveal";
import { finalCTA } from "../../../mocks/pricingData";

export default function FinalCTA() {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden bg-airdoa-navy">
      <div className="relative z-10 px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto text-center">
          <ScrollReveal direction="up">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-semibold text-white leading-tight whitespace-pre-line">
              {finalCTA.title}
            </h2>
            <p className="mt-5 text-sm md:text-base text-white/70">{finalCTA.subtitle}</p>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={200}>
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
              {finalCTA.ctas.map((cta) => {
                if (cta.type === "primary") {
                  return (
                    <Link key={cta.href} to={cta.href} className="btn-primary">
                      {cta.label}
                    </Link>
                  );
                }
                return (
                  <Link key={cta.href} to={cta.href} className="btn-ghost">
                    {cta.label}
                  </Link>
                );
              })}
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}